import React from 'react';
const BadPlugin = ()=>/*#__PURE__*/ React.createElement("div", null, "Bad plugin config, this should never happen.");
BadPlugin.displayName = 'BadPlugin';
export default BadPlugin;
